import React, { useEffect } from 'react';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

const LDFAgreement = ({ agent, customer, bike, saleData, onClose }) => {

  // Safety function: Taki "onClose is not a function" wala error kabhi na aaye
  const handleSafeClose = () => {
    if (onClose && typeof onClose === 'function') {
      onClose();
    } else {
      console.warn("OnClose function provide nahi kiya gaya!");
    }
  };

  // Keyboard support: Escape key se modal band hoga
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.keyCode === 27) handleSafeClose();
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose]);

  const generatePremiumPDF = () => {
    const doc = new jsPDF('p', 'mm', 'a4');
    const refNo = `UM/COMM/${Math.floor(1000 + Math.random() * 9000)}`;
    const date = new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' });

    // 1. OUTER BORDER
    doc.setDrawColor(30, 41, 59);
    doc.setLineWidth(0.7);
    doc.rect(7, 7, 196, 283); 

    // 2. HEADER BLOCK
    doc.setFillColor(15, 23, 42); 
    doc.rect(7, 7, 196, 40, 'F');
    doc.setTextColor(255, 255, 255);
    doc.setFont("times", "bold");
    doc.setFontSize(28);
    doc.text('UNITED MOTORS', 105, 22, { align: 'center' });
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text('AUTHORIZED MOTORCYCLE DEALERSHIP & COMMISSION AGENT', 105, 30, { align: 'center' });
    doc.text(`DATE: ${date}`, 105, 38, { align: 'center' });

    // 3. TITLE
    doc.setTextColor(15, 23, 42);
    doc.setFont("times", "bold");
    doc.setFontSize(18);
    doc.text('VEHICLE SALE & TRANSFER AGREEMENT', 105, 55, { align: 'center' });

    // 4. PARTIES SECTION
    autoTable(doc, {
        startY: 65,
        theme: 'plain',
        styles: { font: 'times', fontSize: 11, cellPadding: 2 },
        body: [
            [{ content: 'SELLER / AGENT DETAILS', styles: { fontStyle: 'bold', textColor: [37, 99, 235] } }, 
             { content: 'BUYER / CUSTOMER DETAILS', styles: { fontStyle: 'bold', textColor: [37, 99, 235] } }],
            [`Full Name: ${agent?.full_name || 'N/A'}`, `Full Name: ${customer?.full_name || 'N/A'}`],
            [`CNIC No: ${agent?.cnic || 'N/A'}`, `CNIC No: ${customer?.cnic || 'N/A'}`],
            [`Mobile: ${agent?.phone || 'N/A'}`, `Mobile: ${customer?.phone || 'N/A'}`],
        ],
        columnStyles: { 0: { cellWidth: 85 }, 1: { cellWidth: 85 } }
    });

    // 5. VEHICLE SPECIFICATIONS
    doc.setFont("times", "bold");
    doc.setFontSize(12);
    doc.text('VEHICLE DESCRIPTION:', 20, doc.lastAutoTable.finalY + 10);

    autoTable(doc, {
        startY: doc.lastAutoTable.finalY + 14,
        theme: 'grid',
        headStyles: { fillColor: [15, 23, 42], fontSize: 11, halign: 'center' },
        bodyStyles: { font: 'times', fontSize: 11, cellPadding: 4 },
        head: [['Specification', 'Vehicle Data']],
        body: [
            ['Make and Model Name', bike?.model_name || 'N/A'],
            ['Registration Number', bike?.registration_number || 'N/A'],
            ['Engine Identification #', bike?.engine_number || 'N/A'],
            ['Chassis Identification #', bike?.chassis_number || '---'],
        ]
    });

    // 6. FINANCIAL SETTLEMENT
    const amountY = doc.lastAutoTable.finalY + 10;
    doc.setFillColor(248, 250, 252);
    doc.rect(20, amountY, 170, 18, 'F'); 
    doc.setDrawColor(15, 23, 42);
    doc.setLineWidth(0.3);
    doc.rect(20, amountY, 170, 18, 'S');

    doc.setFont("times", "bold");
    doc.setFontSize(11);
    doc.text('TOTAL DEAL AMOUNT:', 40, amountY + 11);
    doc.setFontSize(16);
    doc.text(`PKR ${Number(saleData?.total_price || 0).toLocaleString()} /-`, 110, amountY + 11);

    // 7. DECLARATION
    const declY = amountY + 28; 
    doc.setFontSize(11);
    doc.setFont("times", "bold");
    doc.text('DECLARATION & TERMS:', 20, declY);
    
    doc.setFont("times", "normal");
    doc.setFontSize(10);
    const terms = [
        "1. The buyer has inspected the vehicle and accepts it in its current condition.",
        "2. The seller guarantees the vehicle documentation is genuine and free from disputes.",
        "3. Ownership transfer is the sole responsibility of the buyer within 15 working days."
    ];
    doc.text(terms, 20, declY + 7);

    // 8. SIGNATURES
    const sigY = 265;
    doc.setDrawColor(0);
    doc.line(20, sigY, 70, sigY);
    doc.text('Buyer Signature', 32, sigY + 5);

    doc.line(140, sigY, 190, sigY);
    doc.text('Seller / Agent Signature', 150, sigY + 5);

    // Stamp Circle
    doc.setDrawColor(200);
    doc.circle(105, sigY - 5, 12, 'S');
    doc.setFontSize(8);
    doc.text('Dealer Stamp', 105, sigY - 4, { align: 'center' });

    // 9. FOOTER
    doc.setFontSize(8);
    doc.setTextColor(150);
    doc.text('This is an official document generated by United Motors Management System.', 105, 287, { align: 'center' });

    doc.save(`Legal_Agreement_${customer?.full_name || 'Record'}.pdf`);
  };

  return (
    <div style={styles.overlay} onClick={handleSafeClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        
        {/* Top Header */}
        <div style={styles.topBar}>
          <div style={styles.headerTitle}>
            <h3 style={{margin: 0, fontSize: '18px', color: '#1e293b'}}>Agreement Preview</h3>
            <small style={{color: '#64748b'}}>Professional Draft</small>
          </div>
          <button onClick={handleSafeClose} style={styles.closeBtn}>✕</button>
        </div>

        {/* Scrollable Content */}
        <div style={styles.scrollableBody}>
          <div style={styles.paperEffect}>
            
            <div style={styles.brandHeader}>
              <h1 style={styles.logoText}>UNITED MOTORS</h1>
              <div style={styles.badge}>COMMISSION AGREEMENT</div>
            </div>

            <div style={styles.respGrid}>
              <div style={styles.infoCard}>
                <span style={styles.label}>SELLER / AGENT</span>
                <p style={styles.val}>{agent?.full_name || 'Not Provided'}</p>
                <p style={styles.subVal}>CNIC: {agent?.cnic || 'N/A'}</p>
              </div>
              <div style={styles.infoCard}>
                <span style={styles.label}>BUYER / CUSTOMER</span>
                <p style={styles.val}>{customer?.full_name || 'Not Provided'}</p>
                <p style={styles.subVal}>CNIC: {customer?.cnic || 'N/A'}</p>
              </div>
            </div>

            <div style={styles.tableContainer}>
              <table style={styles.uiTable}>
                <thead>
                  <tr style={styles.thRow}>
                    <th style={styles.th}>Bike Information</th>
                    <th style={styles.th}>Technical Specs</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={styles.td}><strong>Model:</strong> {bike?.model_name || 'N/A'}</td>
                    <td style={styles.td}><strong>Engine:</strong> {bike?.engine_number || 'N/A'}</td>
                  </tr>
                  <tr>
                    <td style={styles.td}><strong>Reg #:</strong> {bike?.registration_number || 'N/A'}</td>
                    <td style={styles.td}><strong>Condition:</strong> Verified</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div style={styles.priceSection}>
              <p style={{margin: 0, color: '#64748b', fontSize: '13px'}}>Total Payable Amount</p>
              <h2 style={styles.priceText}>Rs. {Number(saleData?.total_price || 0).toLocaleString()}</h2>
            </div>

            <div style={styles.termsHint}>
              <p>* This agreement is a legal bond between both parties. Please verify all details before printing the final PDF.</p>
            </div>
          </div>
        </div>

        {/* Action Button */}
        <div style={styles.footer}>
          <button onClick={generatePremiumPDF} style={styles.mainBtn}>
            📥 Download PDF
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
    overlay: {
        position: 'fixed', inset: 0, 
        backgroundColor: 'rgba(15, 23, 42, 0.9)', 
        display: 'flex', justifyContent: 'center', alignItems: 'center', 
        zIndex: 99999, padding: '15px', backdropFilter: 'blur(5px)',
        cursor: 'pointer'
    },
    modal: {
        background: '#fff', width: '100%', maxWidth: '800px', 
        maxHeight: '95vh', 
        borderRadius: '20px', display: 'flex', flexDirection: 'column', 
        boxShadow: '0 25px 50px -12px rgba(0,0,0,0.5)', overflow: 'hidden',
        cursor: 'default'
    },
    topBar: {
        padding: '15px 25px', borderBottom: '1px solid #e2e8f0', 
        display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#fff'
    },
    closeBtn: {
        background: '#fee2e2', color: '#ef4444', border: 'none', 
        width: '35px', height: '35px', borderRadius: '50%', cursor: 'pointer', 
        fontWeight: 'bold', fontSize: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center'
    },
    scrollableBody: {
        flex: 1, overflowY: 'auto', 
        padding: '20px', background: '#f8fafc'
    },
    paperEffect: {
        background: '#fff', borderRadius: '12px', border: '1px solid #e2e8f0', 
        padding: '30px', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)'
    },
    brandHeader: {
        textAlign: 'center', marginBottom: '30px', paddingBottom: '20px', borderBottom: '2px solid #f1f5f9'
    },
    logoText: { margin: 0, fontSize: '32px', color: '#0f172a', fontWeight: '900', letterSpacing: '1px' },
    badge: { 
        display: 'inline-block', background: '#374151', color: '#fff', 
        padding: '4px 12px', borderRadius: '20px', fontSize: '11px', marginTop: '10px' 
    },
    respGrid: {
        display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', 
        gap: '20px', marginBottom: '30px'
    },
    infoCard: {
        padding: '20px', background: '#f8fafc', borderRadius: '15px', border: '1px solid #f1f5f9'
    },
    label: { fontSize: '11px', color: '#3b82f6', fontWeight: '800', display: 'block', marginBottom: '8px' },
    val: { margin: '0', fontSize: '18px', fontWeight: 'bold', color: '#1e293b' },
    subVal: { margin: '5px 0 0 0', fontSize: '13px', color: '#64748b' },
    
    tableContainer: { overflowX: 'auto', marginBottom: '30px' },
    uiTable: { width: '100%', borderCollapse: 'collapse' },
    thRow: { background: '#1e293b' },
    th: { padding: '12px', textAlign: 'left', color: '#fff', fontSize: '14px' },
    td: { padding: '15px 12px', borderBottom: '1px solid #f1f5f9', fontSize: '14px', color: '#334155' },
    
    priceSection: {
        background: '#eff6ff', padding: '25px', borderRadius: '15px', 
        textAlign: 'center', border: '2px dashed #3b82f6'
    },
    priceText: { margin: '5px 0 0 0', color: '#1e40af', fontSize: '28px', fontWeight: '900' },
    termsHint: { marginTop: '20px', color: '#94a3b8', fontSize: '11px', textAlign: 'center' },
    
    footer: {
        padding: '20px', borderTop: '1px solid #e2e8f0', textAlign: 'center', background: '#fff'
    },
    mainBtn: {
        background: '#2563eb', color: '#fff', border: 'none', 
        padding: '15px 40px', borderRadius: '12px', fontWeight: 'bold', 
        cursor: 'pointer', width: '100%', fontSize: '16px', boxShadow: '0 10px 15px -3px rgba(37,99,235,0.4)'
    }
};

export default LDFAgreement;